import styled from 'styled-components/native'

export const AspectRatioContainer = styled.View`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
`
